import { getLocation } from '../../../../hooks/useHistory'
import { ToggleStateStorage } from './utils/ToggleStateStorage'

type Listener = (uuid: string, expanded: boolean) => void

export class ToggleStateStore {
  setState(uuid: string, expanded: boolean) {
    const savePromise = ToggleStateStorage.setToggleState(uuid, expanded)
    this._inflight.set(uuid, { newState: expanded, promiseObj: savePromise })
    const removeFromInflight = () => {
      const inflightEntry = this._inflight.get(uuid)
      if (inflightEntry != null && savePromise === inflightEntry.promiseObj) {
        this._inflight.delete(uuid)
      }
    }
    savePromise.then(removeFromInflight, removeFromInflight)
    this._listeners.forEach((listener) => listener(uuid, expanded))
  }

  async getState(uuid: string) {
    const params = new URLSearchParams(getLocation().search)
    if (params.get('print_mode') === 'true') {
      return true
    }
    const inflightEntry = this._inflight.get(uuid)
    if (inflightEntry != null) {
      return inflightEntry.newState
    }
    return ToggleStateStorage.getToggleState(uuid)
  }

  addListener(listener: Listener) {
    this._listeners.add(listener)
    return () => this.removeListener(listener)
  }

  removeListener(listener: Listener) {
    this._listeners.delete(listener)
  }

  private _listeners: Set<Listener> = new Set()

  // A collection of promises to save to the indexeddb that haven't been resolved yet.
  private _inflight: Map<string, { newState: boolean; promiseObj: Promise<void> }> = new Map()
}

export const toggleStateStore = new ToggleStateStore()
